export const AUTH_SESSION_INVALID_EVENT = 'martini:auth-session-invalid'
